<template>
  <div class="flex-col page">
    <div class="flex-row items-start self-stretch group">
      <div class="flex-col relative group_3">
        <div class="self-stretch group_4"></div>
        <div class="flex-col justify-start items-center self-start image-wrapper">
          <img
            class="shrink-0 image_4"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=6fa514c5755b1dfd9e3ab9c6d3da92a3.png"
          />
        </div>
        <img
          class="image pos_2"
          src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=bb1bfeee12504ff46c5603e0e675d586.png"
        />
      </div>
      <div class="flex-col relative group_2">
        <div class="self-end section view"></div>
        <div class="flex-col justify-start items-center self-stretch relative section_2">
          <img
            class="shrink-0 image_3"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=45a24bbcd78c318ab559357b6647b331.png"
          />
          <img
            class="shrink-0 image_3 pos_4"
            src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=6717273db568395cbfdc1a3b66a0916f.png"
          />
        </div>
        <div class="self-center section_4 view_3"></div>
        <img
          class="section pos"
          src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=593ff25ffd277d0071fd5b7056cb6556.png"
        />
        <img
          class="section_4 pos_7"
          src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=1530bfd946daeaa2871afd6080a37af8.png"
        />
      </div>
      <div class="flex-col relative group_5">
        <div class="self-end group_6"></div>
        <div class="self-center section_3 view_2"></div>
        <div class="self-stretch group_7"></div>
        <img
          class="image_2 pos_3"
          src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=c1c976c6c2a4657fd18ebd822df3ecf2.png"
        />
        <img
          class="section_3 pos_5"
          src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=a648c8ee85f3227781d964ec33856888.png"
        />
        <img
          class="image_5 pos_6"
          src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=d17cce364d5f9a81ef60f0512ddb57e7.png"
        />
      </div>
    </div>
    <span class="self-center text">云智迪AI</span>
    <span class="self-center text_2">在10分钟内轻松出色地创作您的短视频</span>
    <div class="flex-col justify-start items-center self-center text-wrapper"><span class="text_3" @click="$router.push({name: 'shouye'})">开始体验</span></div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {},
    data() {
      return {};
    },

    methods: {},
  };
</script>

<style scoped lang="less">
  .page {
    padding: 36px 0 109px;
    background-color: rgb(17, 17, 17);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      overflow-x: hidden;
      .group_3 {
        margin-top: 57px;
        overflow-x: hidden;
        width: 108px;
        .group_4 {
          margin-left: 3px;
          border-radius: 119px;
          overflow: hidden;
          height: 105px;
        }
        .image-wrapper {
          margin-left: -16px;
          margin-top: 85px;
          border-radius: 0 119px 119px 0;
          overflow: hidden;
          width: 124px;
          height: 136px;
          .image_4 {
            width: 124px;
            height: 186px;
          }
        }
        .image {
          border-radius: 119px;
          overflow: hidden;
          width: 105px;
          height: 105px;
        }
        .pos_2 {
          position: absolute;
          left: 3px;
          right: 0;
          top: 0;
        }
      }
      .group_2 {
        width: 164px;
        .section {
          background-color: rgb(255, 255, 255);
          border-radius: 119px;
          overflow: hidden;
          width: 75px;
          height: 75px;
        }
        .view {
          margin-right: 25px;
        }
        .section_2 {
          margin-top: 41px;
          background-color: rgb(255, 255, 255);
          border-radius: 119px;
          overflow: hidden;
          .image_3 {
            width: 164px;
            height: 164px;
          }
          .pos_4 {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
          }
        }
        .section_4 {
          background-color: rgb(255, 255, 255);
          border-radius: 119px;
          overflow: hidden;
          width: 78px;
          height: 78px;
        }
        .view_3 {
          margin-top: 35px;
        }
        .pos {
          position: absolute;
          right: 25px;
          top: 0;
        }
        .pos_7 {
          position: absolute;
          left: 34px;
          bottom: 0;
        }
      }
      .group_5 {
        margin-left: 10px;
        margin-top: 57px;
        overflow-x: hidden;
        width: 108px;
        .group_6 {
          border-radius: 119px 0 0 119px;
          overflow: hidden;
          overflow-x: hidden;
          width: 75px;
          height: 96px;
        }
        .section_3 {
          background-color: rgb(255, 255, 255);
          border-radius: 119px;
          overflow: hidden;
          width: 53px;
          height: 53px;
        }
        .view_2 {
          margin-top: 32px;
        }
        .group_7 {
          margin-top: 42px;
          border-radius: 119px 0 0 119px;
          overflow: hidden;
          height: 126px;
        }
        .image_2 {
          border-radius: 119px 0 0 119px;
          overflow: hidden;
          width: 85px;
          height: 96px;
        }
        .pos_3 {
          position: absolute;
          right: -10px;
          top: 0;
        }
        .pos_5 {
          position: absolute;
          left: 50%;
          top: 128px;
          transform: translateX(-50%);
        }
        .image_5 {
          border-radius: 119px 0 0 119px;
          overflow: hidden;
          width: 108px;
          height: 126px;
        }
        .pos_6 {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
        }
      }
    }
    .text {
      margin-top: 97px;
      color: rgb(255, 255, 255);
      font-size: 48px;
      font-family: Barlow;
      font-weight: 600;
      line-height: 45.5px;
    }
    .text_2 {
      margin-top: 34px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 16px;
      font-family: Barlow;
      line-height: 14.5px;
    }
    .text-wrapper {
      margin-top: 40px;
      padding: 19px 0 22px;
      background-color: rgb(85, 239, 227);
      border-radius: 16px;
      overflow: hidden;
      width: 300px;
      .text_3 {
        color: rgb(17, 17, 17);
        font-size: 22px;
        font-family: Barlow;
        font-weight: 600;
        line-height: 21px;
        letter-spacing: 2px;
      }
    }
  }
</style>
